module.exports = __webpack_public_path__ + "assets/img/1p.59400168.png";